import type { ApproveOrderPlanPayload } from '../../../api/orderPlans.api';
import { buildTenantLoginUrl } from '../../../config/tenantPortal.config';
import type { CredentialsNextLinks } from './CredentialsPopup';

export type ProvisionCredentials = {
  email: string;
  password: string;
  tenantName?: string;
  loginUrl: string;
  nextLinks: CredentialsNextLinks;
};

/** Normalize approve/create-tenant responses into one credentials shape. */
export function buildProvisionCredentials(
  data: ApproveOrderPlanPayload,
  fallbackEmail?: string,
): ProvisionCredentials | null {
  const email = data.admin?.email || fallbackEmail || '';
  const password = data.admin?.password || '';
  if (!email || !password) return null;

  const slug = data.tenant?.slug;
  const loginUrl =
    data.login_url?.trim() ||
    (data.hostname_label
      ? `https://${String(data.hostname_label).replace(/^https?:\/\//i, '').replace(/\/$/, '')}/login`
      : buildTenantLoginUrl(slug));

  const tenantId = data.tenant?.id;
  const subscriptionId =
    data.subscription?.id ??
    (typeof data.request?.subscription_id === 'number' ? data.request.subscription_id : undefined);
  const paymentId = data.payment?.id;

  return {
    email,
    password,
    tenantName: data.tenant?.name || data.hostname_label || slug,
    loginUrl,
    nextLinks: {
      atelierPath: tenantId ? `/ateliers?highlight=${tenantId}` : '/ateliers',
      subscriptionPath: subscriptionId
        ? `/subscriptions?highlight=${subscriptionId}`
        : '/subscriptions',
      paymentsPath: paymentId ? `/payments?highlight=${paymentId}` : '/payments',
    },
  };
}
